<div  id="actionsLists" #actionsLists class="container stdTheme" #refElement style="width: 100%;height: 100%; overflow-x: hidden; overflow-y: hidden;" >
  <div *ngIf="optionItem === 'supplies&parts'" style="width: 100%; overflow-x: hidden; overflow-y: hidden;" >
    <div class="flex-row row" style="width: 100%; margin: 0px; overflow-x: hidden; overflow-y: hidden;">
      <div class="col-1">
        <button [disable]="isReadOnly || !isStockManagment" mat-icon-button 
            matTooltip="{{'valuing parts' | translate}}"
            (click)="getPartsPrices()">
            <mat-icon>money</mat-icon>
        </button>
      </div>
      <div class="col-1">
        <button [disable]="isReadOnly || !isStockManagment" mat-icon-button 
            matTooltip="{{'stock' | translate}}"
            (click)="getPartsAvailaible()">
            <span class="fas fa-warehouse" style="font-size: 20px"  ></span>
        </button>
      </div>
      
      <div class="col-8" style="margin-top: 10px">
        <h6>{{optionItem | translate}}</h6>
      </div>
      <div class="col">
        <button [disable]="isReadOnly" mat-icon-button 
            (click)="addSupplies(0)">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </div>
    </div>
    <div class="flex-row row" style="width: 100%; margin: 0px;overflow-x: hidden!important; overflow-y: hidden!important;">
      <div class="tableActionsReferenced worksReferenced stdTheme col-12" style="padding-left: 0px;padding-right: 0px;" >

          <table class="listAction stdTheme" id="worksSelected" style="padding: 5px" style="overflow-x: hidden; overflow-y: hidden;" >
            <thead  style="margin-left: 5px; margin-right: 5px;">
              <tr class="thTaskRef">
                <th style="width: 5%; padding: 2px" >#</th>
                <th style="width: 5%; padding: 2px" >#</th>
                <th *ngIf="optionItem === 'supplies&parts'" [ngStyle]="{'width': (actionType === 'taskdef') ? '20%' : '20%', 'padding': '2px'}">
                  {{'suppliesLabel' | translate}}
                </th>
                <!--
                <th  *ngIf="optionItem !== 'supplies&parts'" [ngStyle]="{'width': (actionType === 'taskdef') ? '40%' : '20%', 'padding': '2px'}">
                 {{'actionrefLabel' | translate}}
                </th>
                -->
                <th style="width: 10%; padding: 2px">{{'brandRef' | translate}}</th>
                <th style="width: 10%; padding: 2px">{{'billingUnit' | translate}}</th>
                <th style="width: 5%; padding: 2px">{{'quantity' | translate}}</th>
                <th style="width: 10%; padding: 2px">{{'actionTask' | translate}}</th>
                
                <th *ngIf="(actionType === 'withprice')" style="width: 10%; padding: 2px">{{'unitPrice' | translate}}</th>
                <th *ngIf="actionType === 'withprice'" style="width: 10%; padding: 2px">{{'extPrice' | translate}}</th>
                <th *ngIf="actionType === 'withprice'" style="width: 5%; padding: 2px">{{'available' | translate}}</th>
                <th style="width: 5%; padding: 2px" >#</th>
              </tr>
            </thead>
            <tbody  style="margin-left: 5px; margin-right: 5px; overflow-y: auto!important;height: 450px!important;max-height: 450px!important">
              <tr class="trTaskRef curAction curActionDisplayed" *ngFor="let suppliesCur of suppliesList; let i = index"  cdkDrag>
                <td  style="width: 5%; padding: 2px" >
                  <mat-icon style="margin-top: 8px" class="reorder" cdkDragHandle>reorder</mat-icon></td>
                <td style="width: 5%; padding: 2px" >
                  <div *ngIf="!isReadOnly && (suppliesCur.quoted === null || suppliesCur.quoted === '') && !suppliesCur.isParentElement">
                    <button mat-icon-button (click)="removeSupplies(i)">
                        <mat-icon>remove_circle_outline</mat-icon>
                    </button>
                  </div>
                </td>
                <td  [ngStyle]="{'width': (actionType === 'taskdef') ? '20%' : '20%', 'padding': '2px', 'text-align': 'left'}">
                  <input class="form-control inputTheme" name="actionrefLabel" #actionrefLabel value="{{suppliesCur.actionrefLabel}}"
                        matInput (change)="setChangeValuesSupplies('actionrefLabel',actionrefLabel.value, i)"
                        [readonly]="true"
                        [ngClass]="{greenTheme: suppliesCur.status === 'OK', 
                                    amberTheme: suppliesCur.status === 'KO',
                                    redTheme: suppliesCur.status === 'NOT_REFERENCED'}"
                  />
                </td>
                <td style="width: 10%; padding: 2px; text-align: left;">
                  <input class="form-control inputTheme" name="brandRef" #brandRef value="{{suppliesCur.brandRef}}"
                          matInput (change)="setChangeValuesSupplies('brandRef',brandRef.value, i)"
                          [readonly]="true"
                  />
                </td>
                <td style="width: 10%; padding: 2px; text-align: center;">
                  <div >
                    <input class="form-control inputTheme" name="billingUnit" #billingUnit value="{{suppliesCur.billingUnit | translate}}"
                             matInput 
                             [readonly]="true"
                    />
                  </div>
                </td>
                <!-- onchange="setQuantityValue('supplies',quantity.value, i)-->
                <td style="width: 5%; padding: 2px; text-align: right;">
                  <!--JLG 2026-03-03 -->
                  <input class="form-control inputTheme" #supplies_quantity_{{i}} id="supplies_quantity_{{i}}"
                        matInput [attr.data-label]="'supplies_quantity_' + i"
                        (keypress)="numberAndDotOnly($event)" 
                        [value]= "suppliesCur.quantity === 0 ? '' 
                                    :suppliesCur.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal ]"
                        (focus)="unformatNumeric('supplies', 'quantity', 'supplies_quantity_'+i, i)"
                        [readonly]="(isReadOnly ? true : false)"
                        (change)="setChangeValuesSupplies('quantity',$event.target.value, i)"
                  />
                </td>
                <!-- *ngIf="optionItem === 'supplies&parts'"-->
                <td *ngIf="optionItem === 'supplies&parts'"  style="width: 10%; padding: 2px; text-align: right;">
                  <mat-select id="actionTask"  readonly="(isReadOnly ? true : (suppliesCur.quoted === null || suppliesCur.quoted === '') ? false : readonly)"
                      panelClass="mdiselectcontent" [(value)]="suppliesCur.actionTask"  >
                      <mat-option class="selectOptionsTheme" *ngFor="let actionTaskCur of taskActionsList" 
                            (onSelectionChange)="onChangeActionTask($event, i)"
                            [value]="actionTaskCur.value"  >{{actionTaskCur.label }}
                      </mat-option>
                  </mat-select>
                </td>
                <td *ngIf="actionType === 'withprice'"  style="width: 10%; padding: 2px; text-align: right;">
                  <!--JLG 2026-03-03 -->
                  <input class="form-control inputTheme" #supplies_unitPrice_{{i}} id="supplies_unitPrice_{{i}}"
                        matInput [attr.data-label]="'supplies_unitPrice_'+i"
                        (keypress)="numberAndDotOnly($event)" 
                        [value]= "suppliesCur.unitPrice === 0 ? '' 
                                    :suppliesCur.unitPrice | formatNumber : ['currency',numberFormat.locale,numberFormat.currency,'symbol']"
                        (focus)="unformatNumeric('supplies', 'unitPrice', 'supplies_unitPrice_'+i, i)"
                        [readonly]="(isReadOnly ? true : false)"
                        (change)="setChangeValuesSupplies('unitPrice',$event.target.value, i)"
                  />
                </td>
                <td *ngIf="(actionType === 'withprice')"  style="width: 10%; padding: 2px; text-align: right;">
                  <input class="form-control inputTn  heme" #supplies_extPrice_{{i}} id="supplies_extPrice_{{i}}"
                        matInput [attr.data-label]="'supplies_extPrice_'+i"
                        [value]= "suppliesCur.extPrice === 0 ? '' 
                                    :suppliesCur.extPrice | formatNumber : ['currency',numberFormat.locale,numberFormat.currency,'symbol']"
                        [readonly]="true"
                  />
                </td>                
                <td *ngIf="actionType === 'withprice'" class="checkbox-cell">
                  <label class="custom-checkbox">
                    <input type="checkbox"
                          #available
                          class="inputTheme"
                          [disabled]="isReadOnly"
                          [checked]="(suppliesCur.available !== undefined ) ? suppliesCur.available : false" 
                          (change)="setChangeValuesSupplies('available', available.checked, i)">
                    <span class="checkmark"></span>
                  </label>
                </td>
                <td style="width: 5%; padding: 2px" >
                </td>
              </tr>
            </tbody>
          </table>

      </div>
      <!--<div class="col-2"></div>-->
    </div>
  </div>
  <div *ngIf=" optionItem === 'services' " style="width: 100%; overflow-x: hidden; overflow-y: hidden;" >
    <div class="flex-row row" style="width: 100%; margin: 0px; overflow-x: hidden; overflow-y: hidden;">
      <div class="col-1">
      </div>
      <div class="col-10" style="margin-top: 10px">
        <h6>{{optionItem | translate}}</h6>
      </div>
      <div class="col">
        <button [disable]="isReadOnly" mat-icon-button 
            (click)="addServices(0)">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </div>
    </div>
    <div class="flex-row row" style="width: 100%; margin: 0px;">
      <div class="tableActionsReferenced worksReferenced stdTheme col-12" style="padding-left: 0px;padding-right: 0px;" >
          <table class="listAction stdTheme" id="worksSelected" style="padding: 5px" style="overflow-x: hidden; overflow-y: hidden;" >
            <thead  style="margin-left: 5px; margin-right: 5px;">
              <tr class="thTaskRef">
                <th style="width: 5%; padding: 2px" >#</th>
                <th style="width: 5%; padding: 2px" >#</th>
                <th [ngStyle]="{'width': (actionType === 'taskdef') ? '20%' : '20%', 'padding': '2px'}">
                  {{'suppliesLabel' | translate}}
                </th>
                <th style="width: 10%; padding: 2px">{{'brandRef' | translate}}</th>
                <th style="width: 10%; padding: 2px">{{'billingUnit' | translate}}</th>
                <th style="width: 5%; padding: 2px">{{'quantity' | translate}}</th>
                <th *ngIf="actionType === 'withprice'" style="width: 10%; padding: 2px">{{'unitPrice' | translate}}</th>
                <th *ngIf="actionType === 'withprice'" style="width: 10%; padding: 2px">{{'extPrice' | translate}}</th>
                <th style="width: 15%; padding: 2px" >#</th>
              </tr>
            </thead>
            <tbody  style="margin-left: 5px; margin-right: 5px;overflow-x: auto!important;height: 450px!important;max-height: 450px!important">
              <tr class="trTaskRef curAction curActionDisplayed" *ngFor="let servicesCur of servicesList; let i = index"  cdkDrag>
                <td  style="width: 5%; padding: 2px" >
                  <mat-icon style="margin-top: 8px" class="reorder" cdkDragHandle>reorder</mat-icon></td>
                <td style="width: 5%; padding: 2px" >
                  <div *ngIf="!isReadOnly && (servicesCur.quoted === null || servicesCur.quoted === '') && !servicesCur.isParentElement">
                    <button mat-icon-button (click)="removeServices(i)">
                        <mat-icon>remove_circle_outline</mat-icon>
                    </button>
                  </div>
                </td>
                <td  [ngStyle]="{'width': (actionType === 'taskdef') ? '20%' : '20%', 'padding': '2px', 'text-align': 'left'}">
                  <input class="form-control inputTheme" name="actionrefLabel" #actionrefLabel value="{{servicesCur.actionrefLabel}}"
                        matInput 
                        (change)="setChangeValuesServices('actionrefLabel',actionrefLabel.value, i)"
                        [readonly]="true"
                  />
                </td>
                <td style="width: 10%; padding: 2px; text-align: left;">
                  <input class="form-control inputTheme" name="brandRef" #brandRef value="{{servicesCur.brandRef}}"
                          matInput 
                          (change)="setChangeValuesServices('brandRef',brandRef.value, i)"
                          [readonly]="true"
                  />
                </td>
                <td style="width: 10%; padding: 2px; text-align: center;">
                  <input class="form-control inputTheme" name="billingUnit" #billingUnit value="{{servicesCur.billingUnit | translate}}"
                          matInput 
                          (change)="setChangeValuesServices('billingUnit',$event.target.value, i)"
                          [readonly]="true"
                  />
                </td>
                <!-- onchange="setQuantityValue('supplies',quantity.value, i)-->
                <td style="width: 5%; padding: 2px; text-align: right;">
                  <input class="form-control inputTheme" #services_quantity_{{i}} id="services_quantity_{{i}}" 
                        matInput [attr.data-label]="'services_quantity_'+ i"
                        (focus)="unformatNumeric('services', 'quantity', 'services_quantity_'+i, i)"
                        [value]= "servicesCur.quantity === 0 ? '' 
                                    :servicesCur.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal ]"
                        [readonly]="(isReadOnly ? true : false)"
                        (change)="setChangeValuesServices('quantity',$event.target.value, i)"
                  />
                </td>
                <!-- *ngIf="optionItem === 'supplies&parts'"-->
                <td *ngIf="actionType === 'withprice'"  style="width: 10%; padding: 2px; text-align: right;">
                  <input class="form-control inputTheme" #services_unitPrice_{{i}} id="services_unitPrice_{{i}}"
                        matInput [attr.data-label]="'services_unitPrice_'+ i"
                        (focus)="unformatNumeric('services', 'unitPrice', 'services_unitPrice_'+i, i)"
                        [value]= "servicesCur.unitPrice === 0 ? '' 
                                    :servicesCur.unitPrice | formatNumber : ['currency',numberFormat.locale,numberFormat.currency,'symbol']"
                        [readonly]="(isReadOnly ? true : false)"
                        (change)="setChangeValuesServices('unitPrice',$event.target.value, i)"
                  />
                </td>
                <td *ngIf="(actionType === 'withprice')"  style="width: 10%; padding: 2px; text-align: right;">
                  <input class="form-control inputTn  heme" #services_extPrice_{{i}} id="services_extPrice_{{i}}" 
                        matInput [attr.data-label]="'services_extPrice_'+i"
                        [value]= "servicesCur.extPrice === 0 ? '' 
                                    :servicesCur.extPrice | formatNumber : ['currency',numberFormat.locale,numberFormat.currency,'symbol']"
                        [readonly]="true"
                  />
                </td>
                <td style="width: 15%; padding: 2px" >
                </td>
              </tr>
            </tbody>
          </table>
      </div>
      <!--<div class="col-2"></div>-->
    </div>
  </div>
  <div *ngIf="optionItem === 'works'" style="width: 100%" >
    <div class="flex-row row" style="width: 100%; margin: 0px; overflow-x: hidden; overflow-y: hidden;">
      <div class="col-1">

      </div>
      <div class="col-10" style="margin-top: 10px">
        <h6>{{optionItem | translate}}</h6>
      </div>
      <div class="col">
        <button [disable]="isReadOnly" mat-icon-button 
            (click)="addWork(0)">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </div>
    </div>
    <div class="flex-row row" style="width: 100%; margin: 0px;">
      <div class="tableActionsReferenced worksReferenced stdTheme col-12" style="padding-left: 0px;padding-right: 0px;" >
          <table class="listAction stdTheme" id="worksSelected" style="padding: 5px" style="overflow-x: hidden; overflow-y: hidden;" >
            <thead  style="margin-left: 5px; margin-right: 5px;">
              <tr class="thTaskRef">
                <th style="width: 5%; padding: 2px" >#</th>
                <th style="width: 5%; padding: 2px" >#</th>
                <th  [ngStyle]="{'width': (actionType === 'taskdef') ? '20%' : '20%', 'padding': '2px'}">
                  {{'suppliesLabel' | translate}}
                </th>
                <th style="width: 10%; padding: 2px">{{'brandRef' | translate}}</th>
                <th style="width: 10%; padding: 2px">{{'billingUnit' | translate}}</th>
                <th style="width: 5%; padding: 2px">{{'quantity' | translate}}</th>
                <th *ngIf="actionType === 'withprice'" style="width: 10%; padding: 2px">{{'unitPrice' | translate}}</th>
                <th *ngIf="actionType === 'withprice'" style="width: 10%; padding: 2px">{{'extPrice' | translate}}</th>
                <th style="width: 15%; padding: 2px" >#</th>
              </tr>
            </thead>
            <tbody  style="margin-left: 5px; margin-right: 5px;overflow-x: auto!important;height: 450px!important;max-height: 450px!important">
              <tr class="trTaskRef curAction curActionDisplayed" *ngFor="let workCur of worksSelected; let i = index"  cdkDrag>
                <td  style="width: 5%; padding: 2px" >
                  <mat-icon style="margin-top: 8px" class="reorder" cdkDragHandle>reorder</mat-icon></td>
                <td style="width: 5%; padding: 2px" >
                  <div *ngIf="!isReadOnly && (workCur.quoted === null || workCur.quoted === '') && !workCur.isParentElement">
                    <button mat-icon-button (click)="removeWork(i)">
                        <mat-icon>remove_circle_outline</mat-icon>
                    </button>
                  </div>
                </td>
                <td  [ngStyle]="{'width': (actionType === 'taskdef') ? '20%' : '20%', 'padding': '2px', 'text-align': 'left'}">
                  <select class="form-control inputTheme" name="actionrefLabel" #actionrefLabel
                    style="vertical-align: middle;padding-top: 0px;padding-bottom: 0px;"
                    [disabled]="isReadOnly"
                    (change)="referencedToSelected($event.target.value, i)">
                    <option class="selectOptionsTheme" *ngFor="let workReferencedCur of worksReferenced" 
                        [(value)]="workReferencedCur.actionrefId" [selected]="workReferencedCur.actionrefLabel === workCur.actionrefLabel">
                        {{workReferencedCur.actionrefLabel}}
                    </option>
                  </select>
                </td>
                <td style="width: 10%; padding: 2px; text-align: left;">
                  <input class="form-control inputTheme" name="brandRef" #brandRef value="{{workCur.brandRef}}"
                        matInput 
                        (change)="setChangeValuesWorks('brandRef',$event.target.value, i)"
                        [readonly]="true"
                  />
                </td>
                <td style="width: 10%; padding: 2px; text-align: center;">
                  <input class="form-control inputTheme" name="billingUnit" #billingUnit value="{{workCur.billingUnit | translate}}"
                        matInput 
                        [readonly]="true"
                        (change)="setChangeValuesWorks('billingUnit',$event.target.value, i)"
                  />
                </td>
                <td style="width: 5%; padding: 0px; text-align: right;">
                  <input class="form-control inputTheme" #works_quantity_{{i}} id="works_quantity_{{i}}" 
                      matInput [attr.data-label]="'works_quantity_'+ i"
                      (focus)="unformatNumeric('works', 'quantity', 'works_quantity_'+i, i)"
                      [value]= "workCur.quantity === 0 ? '' 
                                    :workCur.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal ]"
                      [readonly]="(isReadOnly ? true: false)"
                      (change)="setChangeValuesWorks('quantity',$event.target.value, i)"
                  />
                </td>
                <td *ngIf="(actionType === 'withprice')"  style="width: 10%; padding: 2px; text-align: right;">
                  <input class="form-control inputTheme" #works_unitPrice_{{i}} id="works_unitPrice_{{i}}"
                        matInput [attr.data-label]="'works_unitPrice_' + i"
                        (focus)="unformatNumeric('works', 'unitPrice', 'works_unitPrice_'+i, i)"
                        [value]= "workCur.unitPrice === 0 ? '' 
                                    :workCur.unitPrice | formatNumber : ['currency',numberFormat.locale,numberFormat.currency,'symbol']"
                        [readonly]="(isReadOnly ? true:  false)"
                        (change)="setChangeValuesWorks('unitPrice',$event.target.value, i)"
                  />
                </td>
                <td *ngIf="actionType === 'withprice'"  style="width: 10%; padding: 2px; text-align: right;">
                  <input class="form-control inputTheme" #works_extPrice_{{i}} id="works_extPrice_{{i}}" 
                        matInput [attr.data-label]="'works_extPrice_' + i"
                         [value]= "workCur.extPrice === 0 ? '' 
                                    :workCur.extPrice | formatNumber : ['currency',numberFormat.locale,numberFormat.currency,'symbol']"
                        [readonly]="true"
                        (change)="setChangeValuesWorks('extPrice',$event.target.value, i)"
                  />
                </td>
                <td style="width: 15%; padding: 2px" >
                </td>
              </tr>
            </tbody>
          </table>
      </div>
      <!--<div class="col-2"></div>-->
    </div>
  </div>
 
</div>

<ng-template #searchModal style="width: 100%">

    <div class="modal-content" >
      <!--
      <div class="modal-header" style="padding-top: 0px;padding-bottom: 0px;">
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      -->
      <div class="modal-body" style="padding: 0px">
          <mdi-parts-supplies-search
            (dataOut)="addListSuppliesModal($event)"
            [statutCall]="'modal'" 
            [optionItem]="'param_actionsref'" 
            [actionType]="'search'"
            [wksEntity]="wksEntity" 
            [suppliesList]="suppliesList"
            [servicesList]="servicesList"
            [typeSearch]="typeSearch"
            [brandName]="(parentTask.parentParam ? parentTask.parentParam.equipBrand ? parentTask.parentParam.equipBrand : undefined : undefined )"
            >
          </mdi-parts-supplies-search>
      </div>
    </div>

</ng-template>
